import Seo from "@/lib/Seo";
import { PageHead } from "@/pages/About";

const NOTE = "المحتوى القانوني النهائي قيد الاعتماد من مالك المحتوى.";

export function Privacy() {
  return (
    <>
      <Seo path="/privacy" title="سياسة الخصوصية" description="سياسة الخصوصية في سياق." />
      <PageHead eyebrow="القانوني" title="سياسة الخصوصية" />
      <div className="bg-paper py-16">
        <div className="mx-auto max-w-[900px] px-6 sm:px-10 space-y-6 text-blue leading-loose text-lg">
          <p className="text-sm" style={{ color: "var(--purple)" }}>{NOTE}</p>
          <p>نلتزم في سياق بحماية خصوصية زوّارنا وعملائنا. نجمع البيانات التي تقدّمها طوعًا عبر نماذج التواصل (الاسم، الجهة، البريد، الجوال، ووصف التحدي) بهدف التواصل معك وتقديم خدماتنا.</p>
          <p>لا نشارك بياناتك مع أطراف ثالثة لأغراض تسويقية، ونستخدمها فقط ضمن غرض جمعها. يمكنك طلب تعديل بياناتك أو حذفها بمراسلتنا على البريد الرسمي.</p>
          <p>قد نستخدم أدوات تحليلية لتحسين تجربة الموقع، دون ربطها بهويتك ما لم توافق على ذلك.</p>
        </div>
      </div>
    </>
  );
}

export function Terms() {
  return (
    <>
      <Seo path="/terms" title="الشروط والأحكام" description="الشروط والأحكام في سياق." />
      <PageHead eyebrow="القانوني" title="الشروط والأحكام" />
      <div className="bg-paper py-16">
        <div className="mx-auto max-w-[900px] px-6 sm:px-10 space-y-6 text-blue leading-loose text-lg">
          <p className="text-sm" style={{ color: "var(--purple)" }}>{NOTE}</p>
          <p>باستخدامك لهذا الموقع فإنك توافق على استخدام محتواه لأغراض التعريف بخدمات سياق فقط. جميع الحقوق الفكرية للمحتوى والهوية محفوظة لسياق.</p>
          <p>لا يجوز إعادة نشر أو استخدام المحتوى تجاريًا دون إذن مكتوب. نسعى لدقة المعلومات المنشورة، وقد نحدّثها دون إشعار مسبق.</p>
        </div>
      </div>
    </>
  );
}
